import { render, staticRenderFns } from "./userworks.vue?vue&type=template&id=7991caa2&scoped=true&"
import script from "./userworks.vue?vue&type=script&lang=js&"
export * from "./userworks.vue?vue&type=script&lang=js&"
import style0 from "./userworks.vue?vue&type=style&index=0&id=7991caa2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7991caa2",
  null
  
)

export default component.exports